import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Megaphone, FileDown, Loader2 } from "lucide-react";
import api, { formatMoney, formatMoney2, formatNumber } from "../lib/api";

const TRAMOS = [["", "Todos"], ["2", "Más de 2 años"], ["1", "1-2 años"]];
const fecha = (v) => (v ? new Date(v).toLocaleDateString("es-ES") : "—");

export function ListaVender() {
  const [tramo, setTramo] = useState("");
  const [limit, setLimit] = useState(50);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/incentivo-parado/lista", { params: { limit, ...(tramo ? { tramo } : {}) } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [tramo, limit]);

  const pdf = async () => {
    setBusy(true);
    try {
      const r = await api.get("/incentivo-parado/lista/pdf", { params: tramo ? { tramo } : {}, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = "productos_para_vender.pdf";
      a.click();
    } catch { toast.error("No se pudo descargar el PDF"); }
    finally { setBusy(false); }
  };

  if (!data) return null;
  return (
    <div className="card p-5 col-span-full" id="ind-lista-vender" data-testid="lista-vender">
      <div className="flex items-start justify-between flex-wrap gap-4 mb-3">
        <div className="max-w-xl">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold flex items-center gap-1"><Megaphone size={12} /> Para el mostrador</div>
          <h3 className="font-display text-xl font-bold">Productos para vender</h3>
          <p className="text-xs text-slate-500 mt-1">Stock D real ordenado por lo que más dinero tiene parado. «Ganas/ud» es lo que cobra el empleado por cada unidad vendida con los % de arriba.</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <div className="inline-flex rounded-lg border border-slate-200 p-0.5" data-testid="lista-vender-tramos">
            {TRAMOS.map(([k, l]) => (
              <button key={k || "todos"} onClick={() => { setTramo(k); setLimit(50); }} data-testid={`lista-vender-tramo-${k || "todos"}`}
                      className={"px-3 py-1.5 text-xs font-semibold rounded-md transition-colors " + (tramo === k ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100")}>{l}</button>
            ))}
          </div>
          <button className="btn btn-outline" onClick={pdf} disabled={busy} data-testid="lista-vender-pdf">{busy ? <Loader2 size={14} className="animate-spin" /> : <FileDown size={14} />} PDF para imprimir</button>
        </div>
      </div>
      <div className="text-xs text-slate-600 mb-3" data-testid="lista-vender-resumen">
        <b>{formatNumber(data.total_refs)}</b> productos · <b>{formatMoney(data.total_valor)}</b> parados · si se vendiera todo, <b className="text-emerald-700">{formatMoney(data.total_incentivo)}</b> de incentivo
      </div>
      <div className="overflow-x-auto">
        <table className="dense w-full" data-testid="lista-vender-tabla">
          <thead><tr><th>CN</th><th>Producto</th><th>Laboratorio</th><th>Antigüedad</th><th>Últ. entrada</th><th className="num">Stock</th><th className="num">PVP</th><th className="num">Valor parado</th><th className="num">Ganas/ud</th></tr></thead>
          <tbody>{data.items.map((i, n) => (
            <tr key={i.cn} data-testid={`lista-vender-fila-${n}`}>
              <td>{i.cn}</td><td className="max-w-xs truncate font-semibold" title={i.descripcion}>{i.descripcion}</td>
              <td className="max-w-[10rem] truncate text-slate-500" title={i.laboratorio}>{i.laboratorio}</td>
              <td><span className={"text-[10px] font-bold px-2 py-0.5 rounded-full " + (i.tramo === "2" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700")}>{i.tramo === "2" ? "+2 años" : "1-2 años"}</span></td>
              <td>{fecha(i.u_entrada)}</td><td className="num">{formatNumber(i.stock)}</td><td className="num">{formatMoney2(i.pvp)}</td>
              <td className="num font-semibold">{formatMoney2(i.valor)}</td><td className="num font-bold text-emerald-700">{formatMoney2(i.incentivo_ud)}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      {data.items.length < data.total_refs && (
        <button className="btn btn-outline btn-sm mt-3" onClick={() => setLimit(limit + 100)} data-testid="lista-vender-mas">Ver 100 más ({formatNumber(data.total_refs - data.items.length)} restantes)</button>
      )}
    </div>
  );
}
